import React from 'react';

import { useTranslation } from 'react-i18next';

import OptionChoice from 'components/application/OptionChoice';
import Options from 'components/application/Options';

export default function MinimalTrainingOptions({
  onDeleteTrainingClick,
  onEditTrainingClick,
}) {
  const { t: i18nT } = useTranslation('components', {
    keyPrefix: 'training.MinimalTrainingOptions',
  });

  const { t: i18nTTraining } = useTranslation('common', {
    keyPrefix: 'training',
  });

  return (
    <Options>
      <OptionChoice>
        <a
          className='tw-text-m tw-font-medium tw-tracking-auto tw-text-grey-700 hover:tw-text-grey-700'
          onClick={onEditTrainingClick}
        >
          {i18nTTraining('editTraining')}
        </a>
      </OptionChoice>
      <OptionChoice warning={true}>
        <a
          className='tw-text-m tw-font-medium tw-tracking-auto tw-text-grey-700 hover:tw-text-grey-700'
          onClick={onDeleteTrainingClick}
        >
          {i18nT('delete')}
        </a>
      </OptionChoice>
    </Options>
  );
}
